'use client';

import { useIntl } from 'react-intl';
import {
  type DialogHeaderProps,
  DialogHeaderBase,
} from '@packages/shared/src/ui/Dialog/DialogHeader/DialogHeaderBase.client';
import { dialogHeaderMessages } from './messages';

export type DialogHeaderLocalizedProps = Omit<
  DialogHeaderProps,
  'ariaLabelBack' | 'ariaLabelClose'
>;

export const DialogHeader = ({ ...props }: DialogHeaderProps) => {
  const { formatMessage } = useIntl();

  return (
    <DialogHeaderBase
      ariaLabelBack={formatMessage(dialogHeaderMessages.back)}
      ariaLabelClose={formatMessage(dialogHeaderMessages.close)}
      {...props}
    />
  );
};
